import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=2df8d47e&"
import script from "./Service.vue?vue&type=script&lang=ts&"
export * from "./Service.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports